import React, { useEffect } from 'react';

import TabPageContainer from '~components/atoms/TabPageContainer';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import GoldConversionApprovalTable from './GoldConversionApprovalTable';
import GoldConversionApprovalTableSearchAndFilterBar from './GoldConversionApprovalSearchAndFilterBar';
import GoldConversionApprovalPaginator from './GoldConversionApprovalPaginator';
import ConfirmUpdateGoldConversionStatusModal from './ConfirmUpdateGoldConversionStatusModal';

const GoldConversionApproval = () => {
    const dispatch = useAppDispatch();
    const pendingGoldConversionIndex = useAppSelector(state => state.approval.pendingGoldConversionListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingGoldConversionListingAttempt());
    }, [pendingGoldConversionIndex]);

    return (
        <TabPageContainer >
            <GoldConversionApprovalTableSearchAndFilterBar />

            <GoldConversionApprovalTable />

            <GoldConversionApprovalPaginator />

            <ConfirmUpdateGoldConversionStatusModal />
        </TabPageContainer>
    );
};

export default GoldConversionApproval;
